(function () {
  'use strict';

  /* ─── Constants ─────────────────────────────────────────────────────────── */
  var SEL = {
    body:            'body.template-collection',
    productItem:     '.CollectionMain .ProductList .ProductItem',
    popupWrapper:    '.pt396_popupWrapper',
    popupContainer:  '.pt396_popupContainer',
    popupOverlay:    '.pt396_popupOverlay',
    closeBtn:        '.pt396_popupWrapper .pt396_closePopup_btn',
    productPopupWrapper: '.pt396_product_popupWrapper',
    popup:           '.pt396_popup',
  };

  /* ─── Utility: poll until predicate returns truthy, then resolve ─────────── */
  function poll(predicate, timeoutMs) {
    timeoutMs = timeoutMs || 10000;
    return new Promise(function (resolve) {
      var id = setInterval(function () {
        var val = predicate();
        if (val) { clearInterval(id); id = null; resolve(val); }
      }, 50);
      setTimeout(function () {
        if (id !== null) { clearInterval(id); console.log('PT396: poll timed out'); }
      }, timeoutMs);
    });
  }

  /* ─── Close modal ────────────────────────────────────────────────────────── */
  function closeModal() {
    var popup = document.querySelector(SEL.popupContainer + ' ' + SEL.popup);
    if (popup) popup.remove();
    document.body.classList.remove('pt396_popupActive');

    var wrapper = document.querySelector(SEL.popupWrapper);
    if (wrapper) {
      // Strip handle class so no stale state leaks to next open
      wrapper.className = wrapper.className
        .split(' ')
        .filter(function (c) { return !c.startsWith('pt396-handle-'); })
        .join(' ');
      wrapper.setAttribute('aria-hidden', 'true');
    }
  }

  /* ─── Flickity carousel init ─────────────────────────────────────────────── */
  function initCarousel() {
    var el = document.querySelector(SEL.popupContainer + ' .pt396_imageContainer > div');
    if (!el || !window.jQuery || !window.jQuery.fn.flickity) return;
    window.jQuery(el).flickity({
      cellAlign: 'left', contain: true, autoPlay: false,
      wrapAround: true, prevNextButtons: true, pageDots: true,
    });
  }

  function loadFlickityThenInit() {
    var FLICKITY_SRC = 'https://cdnjs.cloudflare.com/ajax/libs/flickity/2.2.2/flickity.pkgd.min.js';
    if (document.querySelector('script[src="' + FLICKITY_SRC + '"]')) {
      initCarousel();
    } else {
      var s = document.createElement('script');
      s.src = FLICKITY_SRC;
      s.onload = initCarousel;
      document.body.appendChild(s);
    }
  }

  /* ─── Read live prices from PT242 widget on the ProductItem ─────────────── */
  /**
   * Returns { onetimePrice, subPrice, subLabel } from the live PT242 widget
   * on productItemEl. Falls back to the data-* attributes stamped by Liquid
   * when the PT242 widget hasn't mounted yet (or this product has no PT242).
   */
  function readPrices(productItemEl) {
    var onetimeEl = productItemEl.querySelector(
      '.PT242__OptionWidget--Onetime span.PT242__OptionWidget--Price'
    );
    var subEl = productItemEl.querySelector(
      '.PT242__OptionWidget--Subscription span.PT242__OptionWidget--Price'
    );
    var subLabelEl = productItemEl.querySelector(
      '.PT242__OptionWidget--Subscription span.PT242__OptionWidget--Label'
    );

    var dataWrapper = productItemEl.querySelector(SEL.productPopupWrapper);

    return {
      onetimePrice: (onetimeEl && onetimeEl.textContent.trim())
        || (dataWrapper && dataWrapper.dataset.onetimePrice) || '',
      subPrice: (subEl && subEl.textContent.trim())
        || (dataWrapper && dataWrapper.dataset.subPrice) || '',
      subLabel: (subLabelEl && subLabelEl.textContent.trim())
        || (dataWrapper && dataWrapper.dataset.subLabel) || '',
    };
  }

  /* ─── Refresh prices in the open popup ──────────────────────────────────── */
  /**
   * Called right after the popup is inserted into the modal container.
   * Re-reads prices from the live PT242 widget so stale baked-in values
   * (from Liquid render time) are overwritten with the live widget values.
   * Polls up to 5 s if the PT242 widget isn't ready yet.
   */
  function refreshPopupPrices(productItemEl, popupEl, attempt) {
    attempt = attempt || 0;
    if (attempt > 50) return;

    var prices = readPrices(productItemEl);

    if (!prices.onetimePrice) {
      return setTimeout(function () {
        refreshPopupPrices(productItemEl, popupEl, attempt + 1);
      }, 100);
    }

    /* One-time price slots */
    [
      popupEl.querySelector('span.pt396_one_time_real_price'),
      popupEl.querySelector('.pt_416_onetime_left_price'),
      popupEl.querySelector('.pt_413_subscription_left_normal_price'),
      popupEl.querySelector('span.pt396_subscription_radio_cut_price'),
    ].forEach(function (el) {
      if (el) el.textContent = prices.onetimePrice;
    });

    /* Subscription price slots (only present when has_subscription=true) */
    if (prices.subPrice) {
      [
        popupEl.querySelector('span.pt396_subscription_radio_real_price'),
        popupEl.querySelector('.pt_413_subscription_left_green_price'),
        popupEl.querySelector('span.pt396_addToCart_button_price'),
      ].forEach(function (el) {
        if (el) el.textContent = prices.subPrice;
      });

      if (prices.subLabel) {
        var headingEl = popupEl.querySelector('span.pt396_subscription_radio_heading');
        if (headingEl) headingEl.textContent = prices.subLabel;
      }
    } else {
      /* One-time only — ATC shows one-time price */
      var atcPriceEl = popupEl.querySelector('span.pt396_addToCart_button_price');
      if (atcPriceEl) atcPriceEl.textContent = prices.onetimePrice;
    }
  }

  /* ─── Toggle switch setup (PT416 style) ─────────────────────────────────── */
  /**
   * Wires the subscription ↔ one-time toggle switches inside the popup.
   * productItemEl is passed directly — no handle-class lookup needed.
   */
  function setupToggleSwitches(popupContainer, productItemEl) {
    if (!popupContainer || !productItemEl) return;

    var oneTimeToggle       = popupContainer.querySelector('.pt_416_toggle_input_one_time');
    var subscriptionToggle  = popupContainer.querySelector('.pt_416_toggle_input_subscription');
    var oneTimeWrapper      = popupContainer.querySelector('.pt_416_onetime_wrapper');
    var subscriptionWrapper = popupContainer.querySelector('.pt_416_subscription_wrapper');
    var switchToSubCTA      = popupContainer.querySelector('.pt_416_onetime_left_lower_cta');

    if (!oneTimeToggle && !subscriptionToggle) return; // no toggle UI on this product

    /* Shared helper — switch to subscription view */
    function activateSubscription() {
      if (oneTimeWrapper)      oneTimeWrapper.classList.add('pt_416_hidden');
      if (subscriptionWrapper) subscriptionWrapper.classList.remove('pt_416_hidden');
      var atcPriceEl = popupContainer.querySelector('span.pt396_addToCart_button_price');
      if (atcPriceEl) {
        var prices = readPrices(productItemEl);
        if (prices.subPrice) atcPriceEl.textContent = prices.subPrice;
      }
    }

    /* Shared helper — switch to one-time view */
    function activateOneTime() {
      if (subscriptionWrapper) subscriptionWrapper.classList.add('pt_416_hidden');
      if (oneTimeWrapper)      oneTimeWrapper.classList.remove('pt_416_hidden');
      var atcPriceEl = popupContainer.querySelector('span.pt396_addToCart_button_price');
      if (atcPriceEl) {
        var prices = readPrices(productItemEl);
        if (prices.onetimePrice) atcPriceEl.textContent = prices.onetimePrice;
      }
    }

    /* Helper: populate static price spans on open */
    function applyPrices() {
      var prices = readPrices(productItemEl);
      var normalPriceEl = popupContainer.querySelector('.pt_413_subscription_left_normal_price');
      var greenPriceEl  = popupContainer.querySelector('.pt_413_subscription_left_green_price');
      var oneBoxPrice   = popupContainer.querySelector('.pt_416_onetime_left_price');
      if (normalPriceEl) normalPriceEl.textContent = prices.onetimePrice;
      if (oneBoxPrice)   oneBoxPrice.textContent   = prices.onetimePrice;
      if (greenPriceEl && prices.subPrice) greenPriceEl.textContent = prices.subPrice;
    }

    /* Poll once if prices aren't stamped yet */
    poll(function () { return readPrices(productItemEl).onetimePrice; }, 5000)
      .then(applyPrices);

    /* Toggle from one-time → subscription */
    if (oneTimeToggle) {
      oneTimeToggle.addEventListener('click', activateSubscription);
    }

    /* Toggle from subscription → one-time */
    if (subscriptionToggle) {
      subscriptionToggle.addEventListener('click', activateOneTime);
    }

    /* "Switch to Subscription!" CTA link inside the one-time wrapper */
    if (switchToSubCTA) {
      switchToSubCTA.addEventListener('click', activateSubscription);
    }
  }

  /* ─── Radio-row selection (one-time / subscription) ─────────────────────── */
  /**
   * Toggles the active radio row and updates the ATC button price.
   */
  function handleRadioClick(evt, otRow, subRow, atcPriceSpan) {
    otRow.classList.remove('pt_396_active_block');
    subRow.classList.remove('pt_396_active_block');
    evt.currentTarget.classList.add('pt_396_active_block');

    if (evt.currentTarget === subRow) {
      var subReal = subRow.querySelector('.pt396_subscription_radio_real_price');
      if (subReal && atcPriceSpan) atcPriceSpan.textContent = subReal.textContent;
    } else {
      var otReal = otRow.querySelector('.pt396_one_time_real_price');
      if (otReal && atcPriceSpan) atcPriceSpan.textContent = otReal.textContent;
    }
  }

  /* ─── Add-to-cart handler ────────────────────────────────────────────────── */
  /**
   * Reads data-var-id from the popup ATC button.
   * Finds the matching hidden ATC button on the ProductItem (not document-wide),
   * syncs the PT242 widget state, then clicks it.
   */
  function handleAddToCart(evt) {
    var popupBtn    = evt.currentTarget;
    var varId       = popupBtn.dataset.varId;
    var popupEl     = popupBtn.closest(SEL.popup);
    var popupWrap   = document.querySelector(SEL.popupWrapper);

    /* Resolve the originating ProductItem via the handle class on the wrapper */
    var handleClass = popupWrap
      ? Array.from(popupWrap.classList).find(function (c) { return c.startsWith('pt396-handle-'); })
      : null;
    var handle      = handleClass ? handleClass.replace('pt396-handle-', '') : null;

    var productItemEl = handle
      ? document.querySelector('.ProductItem[data-product-handle="' + handle + '"], .ProductItem.' + handle)
      : null;

    /* Fall back: find by var_id across all visible ProductItems */
    if (!productItemEl) {
      productItemEl = (function () {
        var items = document.querySelectorAll(SEL.productItem);
        for (var i = 0; i < items.length; i++) {
          if (items[i].querySelector('[data-var_id="' + varId + '"], [data-var-id="' + varId + '"]')) {
            return items[i];
          }
        }
        return null;
      }());
    }

    if (!productItemEl) {
      console.warn('PT396: cannot find ProductItem for varId', varId);
      return;
    }

    var nativeAtcBtn = productItemEl.querySelector(
      ".ProductItem_AddToCartBtn button[data-var_id='" + varId + "']," +
      ".ProductItem_AddToCartBtn button[data-var-id='" + varId + "']"
    );
    if (!nativeAtcBtn) {
      console.warn('PT396: native ATC button not found for varId', varId);
      return;
    }

    /* Determine which purchase option is active in the popup */
    var dataWrapper = productItemEl.querySelector(SEL.productPopupWrapper);
    var hasSubscription = dataWrapper && dataWrapper.dataset.hasSubscription === 'true';

    if (!hasSubscription) {
      /* One-time only — just click native ATC and close */
      nativeAtcBtn.click();
      closeModal();
      return;
    }

    /* Subscription product — determine active mode from PT416 wrapper visibility */
    // PT416 layout: subscription is active when .pt_416_onetime_wrapper is hidden
    // (i.e. .pt_416_hidden is present on it), or when .pt_416_subscription_wrapper
    // is visible. Falls back to old radio-row active block for non-PT416 layouts.
    var isSubscriptionActive = false;
    var isOneTimeActive      = false;

    if (popupEl) {
      var pt416OTWrapper  = popupEl.querySelector('.pt_416_onetime_wrapper');
      var pt416SubWrapper = popupEl.querySelector('.pt_416_subscription_wrapper');

      if (pt416OTWrapper && pt416SubWrapper) {
        // PT416 toggle layout — check which wrapper is currently visible
        isOneTimeActive      = !pt416SubWrapper.classList.contains('pt_416_hidden') === false
                            || pt416OTWrapper.classList.contains('pt_416_hidden') === false;
        // Simpler: subscription is active when onetime wrapper IS hidden
        isSubscriptionActive = pt416OTWrapper.classList.contains('pt_416_hidden');
        isOneTimeActive      = !isSubscriptionActive;
      } else {
        // Fallback: old radio-row active block
        var activeBlock = popupEl.querySelector('.pt396_subscription_wrapper .pt_396_active_block');
        if (activeBlock) {
          isSubscriptionActive = activeBlock.classList.contains('pt396_subscription_radio_wrapper');
          isOneTimeActive      = activeBlock.classList.contains('pt396_one_time_radio_wrapper');
        }
      }
    }

    if (isOneTimeActive) {
      // ── OTP path: bypass PT242 entirely — add directly via Cart API ──────────
      // PT242 always defaults to subscription; clicking its native ATC would add
      // a subscription regardless of what we clicked in the widget. Instead we
      // POST directly to /cart/add.js with just the variant ID and no selling_plan.
      addOneTimeToCart(varId, function (ok) {
        if (!ok) {
          // Cart API failed — last resort: click the PT242 onetime option then ATC
          var widgetOptions = productItemEl.querySelector('.PT242__OptionWidget--Options');
          if (widgetOptions) {
            var otBtn = widgetOptions.querySelector('.PT242__OptionWidget--Onetime');
            if (otBtn) {
              otBtn.click();
              setTimeout(function () {
                var pt242ATC = productItemEl.querySelector('button.PT242__OptionWidget--Button');
                if (pt242ATC) pt242ATC.click();
              }, 300);
            }
          }
        }
        closeModal();
      });
      return;
    }

    // ── Subscription path: sync PT242 widget then trigger its ATC ────────────
    poll(function () {
      return productItemEl.querySelectorAll('.PT242__OptionWidget--Options').length > 0;
    }, 50000).then(function () {
      var widgetOptions = productItemEl.querySelector('.PT242__OptionWidget--Options');
      if (!widgetOptions) { nativeAtcBtn.click(); closeModal(); return; }

      var subBtn = widgetOptions.querySelector('.PT242__OptionWidget--Subscription');
      if (subBtn) subBtn.click();

      // Poll until PT242 confirms subscription is active, then click its ATC
      poll(function () {
        return productItemEl.querySelector('.PT242__OptionWidget--Subscription.PT242__OptionWidget--Active') !== null;
      }, 3000).then(function () {
        var pt242ATC = productItemEl.querySelector('button.PT242__OptionWidget--Button');
        if (pt242ATC) pt242ATC.click();
        closeModal();
      });
    });
  }

  /* ─── Add one-time variant to cart via Cart API (no selling_plan) ────────── */
  function addOneTimeToCart(variantId, callback) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{
          id: Number(variantId),
          quantity: 1,
          properties: { _no_discount: 'true' }
        }]
      })
    })
    .then(function (res) {
      if (!res.ok) throw new Error('Add to cart failed: ' + res.status);
      return res.json();
    })
    .then(function () {
      // Mirror exactly what PT242 does after a successful cart add
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:refresh', { bubbles: true })
      );
      document.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: { variant: Number(variantId), quantity: 1 }
      }));
      // Open cart drawer the same way PT242 does
      var cartDrawer = document.querySelector('.cart_dr');
      if (cartDrawer) cartDrawer.click();
      callback(true);
    })
    .catch(function (err) {
      console.warn('PT396: Cart API error', err);
      callback(false);
    });
  }

  /* ─── Open modal for a ProductItem ──────────────────────────────────────── */
  function openModal(productItemEl) {
    var popupSourceEl = productItemEl.querySelector(SEL.popup);
    if (!popupSourceEl) {
      console.warn('PT396: .pt396_popup not found on', productItemEl);
      return;
    }

    var clonedPopup    = popupSourceEl.cloneNode(true);
    var modalContainer = document.querySelector(SEL.popupContainer);
    if (!modalContainer) return;

    /* Inject cloned popup */
    modalContainer.insertAdjacentElement('beforeend', clonedPopup);

    /* Carousel */
    if (modalContainer.querySelector('.pt396_imageContainer > div')) {
      setTimeout(loadFlickityThenInit, 100);
    }

    /* Add-to-cart — copy varId from the Liquid data attribute */
    var atcBtn = modalContainer.querySelector('.pt396_addToCart_button');
    var dataWrapper = productItemEl.querySelector(SEL.productPopupWrapper);
    if (atcBtn && dataWrapper) {
      atcBtn.dataset.varId = dataWrapper.dataset.variantId;
    }
    if (atcBtn) atcBtn.addEventListener('click', handleAddToCart);

    /* Ingredient accordion */
    var accordionBtn     = modalContainer.querySelector('.pt396_ingredient_accordian_button');
    var accordionContent = modalContainer.querySelector('.pt396_ingredient_accordian_dropdown_content');
    var accordionSection = modalContainer.querySelector('.pt396_productAccordian');

    if (accordionBtn && accordionContent) {
      accordionBtn.addEventListener('click', function () {
        var expanded = accordionBtn.getAttribute('aria-expanded') === 'true';
        accordionBtn.setAttribute('aria-expanded', String(!expanded));
        accordionContent.classList.toggle('pt_396_drop_active');
      });
      if (accordionContent.innerHTML.trim() === '' && accordionSection) {
        accordionSection.classList.add('pt_396_no_content_ingredient_hidden');
      }
    } else if (accordionSection) {
      accordionSection.classList.add('pt_396_no_content_ingredient_hidden');
    }

    /* Radio rows (old-style subscription widget — present only on some products) */
    var subWrapper   = modalContainer.querySelector('.pt396_subscription_wrapper');
    if (subWrapper) {
      var otRow        = subWrapper.querySelector('.pt396_one_time_radio_wrapper');
      var subRow       = subWrapper.querySelector('.pt396_subscription_radio_wrapper');
      var atcPriceSpan = modalContainer.querySelector('button.pt396_addToCart_button .pt396_addToCart_button_price');

      if (otRow && subRow) {
        otRow.addEventListener('click', function (t) {
          /* Sync PT242 widget */
          var otWidget  = productItemEl.querySelector('.PT242__OptionWidget .PT242__OptionWidget--Onetime');
          var subWidget = productItemEl.querySelector('.PT242__OptionWidget .PT242__OptionWidget--Subscription');
          if (otWidget)  otWidget.classList.add('PT242__OptionWidget--Active');
          if (subWidget) subWidget.classList.remove('PT242__OptionWidget--Active');
          handleRadioClick(t, otRow, subRow, atcPriceSpan);
        });

        subRow.addEventListener('click', function (t) {
          var otWidget  = productItemEl.querySelector('.PT242__OptionWidget .PT242__OptionWidget--Onetime');
          var subWidget = productItemEl.querySelector('.PT242__OptionWidget .PT242__OptionWidget--Subscription');
          if (otWidget)  otWidget.classList.remove('PT242__OptionWidget--Active');
          if (subWidget) subWidget.classList.add('PT242__OptionWidget--Active');
          handleRadioClick(t, otRow, subRow, atcPriceSpan);
        });
      }
    }

    /* Set handle class on wrapper for any legacy CSS that still uses it */
    var popupWrapperEl = document.querySelector(SEL.popupWrapper);
    var productHandle  = dataWrapper ? dataWrapper.dataset.productHandle : null;
    if (popupWrapperEl && productHandle) {
      popupWrapperEl.className = popupWrapperEl.className
        .split(' ')
        .filter(function (c) { return !c.startsWith('pt396-handle-'); })
        .join(' ');
      popupWrapperEl.classList.add('pt396-handle-' + productHandle);
      popupWrapperEl.setAttribute('aria-hidden', 'false');
    }

    /* Refresh prices from live PT242 widget (overwrites Liquid baked-in prices) */
    refreshPopupPrices(productItemEl, clonedPopup);

    /* Wire PT416 toggle switches */
    setupToggleSwitches(modalContainer, productItemEl);

    /* Activate body class */
    document.body.classList.add('pt396_popupActive');
  }

  /* ─── Per-ProductItem setup (called by optiReady) ────────────────────────── */
  /**
   * Instead of fetching the product page, we simply wait for the Liquid-rendered
   * .pt396_product_popupWrapper to be in the DOM (it's always there — rendered
   * server-side) and then bind click handlers on all anchors inside the card.
   */
  function initProductItem(productItemEl) {
    /* The popup wrapper is already in the DOM; just wait for PT242 widget */
    poll(function () {
      return productItemEl.querySelector(SEL.productPopupWrapper) !== null;
    }, 10000).then(function () {

      productItemEl.classList.add('pt_396_disable_link');

      productItemEl.querySelectorAll('a[href]').forEach(function (anchor) {
        anchor.addEventListener('click', function (evt) {
          evt.preventDefault();

          var clickedProductEl = evt.target.closest(SEL.productItem);
          if (!clickedProductEl) return;

          openModal(clickedProductEl);
        });
      });

      productItemEl.classList.remove('pt_396_disable_link');
    });
  }

  /* ─── Bootstrap ─────────────────────────────────────────────────────────── */
  (function bootstrap() {
    /* Register test in optiActiveTests */
    window.optiActiveTests = window.optiActiveTests || {};
    window.optiActiveTests['PT_396'] = 'v2-liquid';

    poll(function () {
      return document.querySelector(SEL.body) !== null
        && window.location.href.includes('collections/')
        && typeof window.jQuery === 'function';
    }).then(function () {

      /* Mobile only */
      if (window.innerWidth > 767) return;

      /* Inject optiReady if absent */
      if (typeof window.optiReady !== 'function') {
        var _entries = [], _doc = document,
            _MO = window.MutationObserver || window.WebKitMutationObserver,
            _observer;

        function _scan() {
          _entries.forEach(function (entry, idx) {
            _doc.querySelectorAll(entry.selector).forEach(function (node) {
              node._optiReady = node._optiReady || {};
              if (!node._optiReady[idx]) {
                node._optiReady[idx] = true;
                entry.fn.call(node, node);
              }
            });
          });
        }

        window.optiReady = function (selector, fn) {
          _entries.push({ selector: selector, fn: fn });
          if (!_observer) {
            _observer = new _MO(_scan);
            _observer.observe(_doc.documentElement, { childList: true, subtree: true });
          }
          _scan();
        };
      }

      document.body.classList.add('pt_396');

      /* Ensure modal shell exists */
      if (!document.querySelector(SEL.popupWrapper)) {
        console.warn('PT396: .pt396_popupWrapper not found. Did you render pt396-quickview-modal?');
        return;
      }

      /* Global overlay / close button */
      var overlay  = document.querySelector(SEL.popupOverlay);
      var closeBtn = document.querySelector(SEL.closeBtn);
      if (overlay)  overlay.addEventListener('click',  closeModal);
      if (closeBtn) closeBtn.addEventListener('click', closeModal);

      /* Keyboard close */
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeModal();
      });

      /* Init each ProductItem */
      window.optiReady(SEL.productItem, function (productItemEl) {
        initProductItem(productItemEl);
      });
    });
  }());

}());